import { Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import {
  getHistoryTimeArea,
  putEndRegionTime,
  putStartRegionTime,
} from "../../api/area";
import ClockIcon from "../../assets/SVG/clockIcon";
import CustomTable from "../customTable/CustomTable";
import { arrNumber2 } from "../Helper/helper";
import { Modal } from "../modal";

export default function HistoryArea({ dataArea }) {
  const [start, setStart] = useState(false);
  const [dataTime, setDataTime] = useState();

  useEffect(() => {
    if (dataArea[0]?.areas[0]?.id) {
      getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
        .then((x) => setDataTime(x))
        .catch(() => {});
    }
  }, [dataArea[0]?.areas[0]?.id]);
  useEffect(() => {
    if (dataTime) {
      for (let i = 0; i < dataTime.length; i++) {
        if (dataTime.length === i + 1) {
          if (!dataTime[i].end) {
            setStart(true);
          }
        }
      }
    }
  }, [dataTime]);

  const colDefs = useMemo(
    () => [
      {
        headerName: "نام",
        width: 150,
        cellRenderer: (params) => `شروع ${arrNumber2[params.node.rowIndex]}`,
      },
      {
        headerName: "زمان",
        width: 250,
        cellRenderer: (x) => {
          return (
            <Typography
              key={`date_${x.id}`}
              fontFamily="Vazirmatn"
              sx={{ lineHeight: "unset" }}
            >
              {`${x.data?.start} ${x.data?.end !== undefined && x.data?.end !== null ? `تا ${x.data?.end}` : ""}`}
            </Typography>
          );
        },
      },
    ],
    [],
  );

  return (
    <Modal
      icon={<ClockIcon color="var(--emr-primary)" />}
      title={"شروع/توقف"}
      actionButton={
        !start ? (
          <Button
            width="80px"
            variant="contained"
            onClick={() => {
              putStartRegionTime(dataArea[0]?.areas[0]?.id)
                .then((x) => {
                  setStart(true);
                  getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
                    .then((x) => setDataTime(x))
                    .catch(() => {});
                })
                .catch(() => {});
            }}
          >
            شروع
          </Button>
        ) : (
          <Button
            width="80px"
            variant="contained"
            color="error"
            onClick={() => {
              putEndRegionTime(dataArea[0]?.areas[0]?.id)
                .then((x) => {
                  setStart(false);
                  getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
                    .then((x) => setDataTime(x))
                    .catch(() => {});
                })
                .catch(() => {});
            }}
          >
            توقف
          </Button>
        )
      }
    >
      <Grid display={"block"} sx={{ paddingTop: "20px", height: "stretch" }}>
        {dataTime && (
          <CustomTable
            columns={colDefs}
            rowData={dataTime}
            needPagination={false}
          />
        )}
      </Grid>
    </Modal>
  );
}
